const USER_INFO = {
  USER_NAME: "Automation",
  USER_ID: 13,
  SOURCE_ID: 14,
};

const STATUS_ID = {
  DRAFT: 25,
  ORDER: 1,
};

const COUNTRY = {
  US: {
    KEY: "US",
    LABEL: "United States",
    COUNTRY_CODE: "001",
  },
  CA: {
    KEY: "CA",
    LABEL: "Canada",
    COUNTRY_CODE: "002",
  },
};
const ITEM_PER_PAGE_FOR_TABLE = [
  { id: 1, value: 20 },
  { id: 2, value: 30 },
  { id: 3, value: 50 },
  { id: 4, value: 100 },
];
export const allowedTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
  "image/gif",
  "image/webp",
  "image/svg+xml",
];

export const allowedExt = ["jpeg", "jpg", "png", "pdf", "gif", "webp", "svg"];

export const STATUS_LIST = [
  { id: 0, label: "Select...", value: 0 },
  { id: 1, label: "Open", value: 1 },
  { id: 2, label: "In Progress", value: 2 },
  { id: 3, label: "Completed", value: 11 },
  { id: 4, label: "Canceled", value: 12 },
];

export const REFERRAL_LIST = [
  { id: 0, label: "Select...", value: 0 },
  { id: 1, label: "Publication", value: 1 },
  { id: 2, label: "Digital", value: 2 },
  { id: 3, label: "Social Media", value: 3 },
  { id: 4, label: "Email Marketing", value: 4 },
  { id: 5, label: "CCC", value: 5 },
  { id: 6, label: "LKQ", value: 6 },
  { id: 7, label: "Elitek", value: 7 },
  { id: 8, label: "Other", value: 8 },
];

export const DATE_RANGES = [
  { id: 0, label: "Last 7 Days", value: 7 },
  { id: 1, label: "Last 14 Days", value: 14 },
  { id: 2, label: "Last 30 Days", value: 30 },
  { id: 3, label: "Last 60 Days", value: 60 },
  { id: 4, label: "Last 90 Days", value: 90 },
  { id: 5, label: "Custom", value: 0 },
];

export const US_STATES = [
{id: 0,countryID:1,label: "Select...",value: "Select"},
{id: 1,countryID:1,label: "Alabama",value: "AL"},
{id: 2,countryID:1,label: "Alaska",value: "AK"},
{id: 3,countryID:1,label: "American Samoa",value: "AS"},
{id: 4,countryID:1,label: "Arizona",value: "AZ"},
{id: 5,countryID:1,label: "Arkansas",value: "AR"},
{id: 6,countryID:1,label: "Armed Forces Americas",value: "AA"},
{id: 7,countryID:1,label: "Armed Forces Europe",value: "AE"},
{id: 8,countryID:1,label: "Armed Forces Pacific",value: "AP"},
{id: 9,countryID:1,label: "California",value: "CA"},
{id: 10,countryID:1,label: "Colorado",value: "CO"},
{id: 11,countryID:1,label: "Connecticut",value: "CT"},
{id: 12,countryID:1,label: "Delaware",value: "DE"},
{id: 13,countryID:1,label: "District of Columbia",value: "DC"},
{id: 14,countryID:1,label: "Florida",value: "FL"},
{id: 15,countryID:1,label: "Georgia",value: "GA"},
{id: 16,countryID:1,label: "Guam",value: "GU"},
{id: 17,countryID:1,label: "Hawaii",value: "HI"},
{id: 18,countryID:1,label: "Idaho",value: "ID"},
{id: 19,countryID:1,label: "Illinois",value: "IL"},
{id: 20,countryID:1,label: "Indiana",value: "IN"},
{id: 21,countryID:1,label: "Iowa",value: "IA"},
{id: 22,countryID:1,label: "Kansas",value: "KS"},
{id: 23,countryID:1,label: "Kentucky",value: "KY"},
{id: 24,countryID:1,label: "Louisiana",value: "LA"},
{id: 25,countryID:1,label: "Maine",value: "ME"},
{id: 26,countryID:1,label: "Maryland",value: "MD"},
{id: 27,countryID:1,label: "Massachusetts",value: "MA"},
{id: 28,countryID:1,label: "Michigan",value: "MI"},
{id: 29,countryID:1,label: "Minnesota",value: "MN"},
{id: 30,countryID:1,label: "Mississippi",value: "MS"},
{id: 31,countryID:1,label: "Missouri",value: "MO"},
{id: 32,countryID:1,label: "Montana",value: "MT"},
{id: 33,countryID:1,label: "Nebraska",value: "NE"},
{id: 34,countryID:1,label: "Nevada",value: "NV"},
{id: 35,countryID:1,label: "New Hampshire",value: "NH"},
{id: 36,countryID:1,label: "New Jersey",value: "NJ"},
{id: 37,countryID:1,label: "New Mexico",value: "NM"},
{id: 38,countryID:1,label: "New York",value: "NY"},
{id: 39,countryID:1,label: "North Carolina",value: "NC"},
{id: 40,countryID:1,label: "North Dakota",value: "ND"},
{id: 41,countryID:1,label: "Northern Mariana Islands",value: "MP"},
{id: 42,countryID:1,label: "Ohio",value: "OH"},
{id: 43,countryID:1,label: "Oklahoma",value: "OK"},
{id: 44,countryID:1,label: "Oregon",value: "OR"},
{id: 45,countryID:1,label: "Pennsylvania",value: "PA"},
{id: 46,countryID:1,label: "Puerto Rico",value: "PR"},
{id: 47,countryID:1,label: "Rhode Island",value: "RI"},
{id: 48,countryID:1,label: "South Carolina",value: "SC"},
{id: 49,countryID:1,label: "South Dakota",value: "SD"},
{id: 50,countryID:1,label: "Tennessee",value: "TN"},
{id: 51,countryID:1,label: "Texas",value: "TX"},
{id: 52,countryID:1,label: "U.S. Virgin Islands",value: "VI"},
{id: 53,countryID:1,label: "Utah",value: "UT"},
{id: 54,countryID:1,label: "Vermont",value: "VT"},
{id: 55,countryID:1,label: "Virginia",value: "VA"},
{id: 56,countryID:1,label: "Washington",value: "WA"},
{id: 57,countryID:1,label: "West Virginia",value: "WV"},
{id: 58,countryID:1,label: "Wisconsin",value: "WI"},
{id: 59,countryID:1,label: "Wyoming",value: "WY"}
];

export const CANADA_STATES = [
{id: 0,countryID:2,label: "Select...",value: "Select"},
{id: 60,countryID:2,label: "Alberta",value: "AB"},
{id: 61,countryID:2,label: "British Columbia",value: "BC"},
{id: 62,countryID:2,label: "Manitoba",value: "MB"},
{id: 63,countryID:2,label: "New Brunswick",value: "NB"},
{id: 64,countryID:2,label: "Newfoundland and Labrador",value: "NL"},
{id: 65,countryID:2,label: "Northwest Territories",value: "NT"},
{id: 66,countryID:2,label: "Nova Scotia",value: "NS"},
{id: 67,countryID:2,label: "Nunavut",value: "NU"},
{id: 68,countryID:2,label: "Ontario",value: "ON"},
{id: 69,countryID:2,label: "Prince Edward Island",value: "PE"},
{id: 70,countryID:2,label: "Quebec",value: "QC"},
{id: 71,countryID:2,label: "Saskatchewan",value: "SK"},
{id: 72,countryID:2,label: "Yukon",value: "YT"}
];

export { USER_INFO, STATUS_ID, COUNTRY, ITEM_PER_PAGE_FOR_TABLE };
